import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-confirmacion-recupero-fondos',
  templateUrl: './confirmacion-recupero-fondos.component.html',
  styleUrls: ['./confirmacion-recupero-fondos.component.scss'],
})
export class ConfirmacionRecuperoFondosComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      aprobado: [values ? values.aprobado : '', [Validators.required]],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
